import locale0en from './en.json';
import locale1es from './es.json';
import type { LegalDocumentMap } from '../types';

export const GENERATED_LEGAL_LOCALES = [
    'en',
    'es',
] as const;

export type GeneratedLegalLocale = typeof GENERATED_LEGAL_LOCALES[number];

const legalDocumentsByLocale: Readonly<Record<GeneratedLegalLocale, LegalDocumentMap>> = {
    'en': locale0en as LegalDocumentMap,
    'es': locale1es as LegalDocumentMap,
};

export function loadGeneratedLegalDocuments(locale: GeneratedLegalLocale): LegalDocumentMap;
export function loadGeneratedLegalDocuments(locale: string): LegalDocumentMap {
    const documents = (legalDocumentsByLocale as Partial<Record<string, LegalDocumentMap>>)[locale];
    if (!documents) {
        return legalDocumentsByLocale.en;
    }
    return documents;
}

export const englishLegalDocuments = loadGeneratedLegalDocuments('en');
